export function formatCAD(n) {
  return new Intl.NumberFormat("en-CA", { style: "currency", currency: "CAD" }).format(n || 0);
}

export function classNames(...a) {
  return a.filter(Boolean).join(" ");
}
